import curry from 'lodash/fp/curry'
import prop from 'lodash/fp/prop'
import isNil from 'lodash/isNil'
import * as App from './app'
import * as Constants from './constants'
import { ApplicationState } from './rootReducer'
import * as Types from './types'

export const remove = (arr: any[] = [], index: number) => [
  ...arr.slice(0, Math.min(index, arr.length)),
  ...arr.slice(Math.min(index + 1, arr.length), arr.length),
]

export const replace = (arr: any[] = [], index: number, item: any) => [
  ...arr.slice(0, Math.min(index, arr.length)),
  item,
  ...arr.slice(Math.min(index + 1, arr.length), arr.length),
]

export const insert = (arr: any[] = [], index: number, item: any) => [
  ...arr.slice(0, Math.min(index, arr.length)),
  item,
  ...arr.slice(Math.min(index, arr.length)),
]

// TODO: implement a splice method for array of objects similar to the native splice method of arrays
export const concat = curry((a: string, b: string) => a.concat(b))
export const join = curry((a: string, b: string) => concat(a, concat('_', b)))

export const createConstants = curry((verbs: string[], anotherPrefix: string, prefix: string) =>
  verbs.map((verb) => `${anotherPrefix}${join(prefix, verb)}`))
export type SelectedValue = <Event = React.SyntheticEvent>(e: Event) => App.CommunityIdentifier
export const selectValue: SelectedValue = prop('target.value')
export type SelectedCommunity = (state: ApplicationState) => App.CommunityIdentifier
export const selectedCommunity: SelectedCommunity = prop('app.selectedCommunity')

export interface CSVHeader {
  name: string, // this would be column name returned by api
  displayName?: string // this would be column name in CSV
}

export const downloadCSV = (data: any[],  headers: CSVHeader[], filename?: string) => {
  if (data.length > 0) {
    const outputData: string[] = [];
    const outputHeader: string[] = [];
    const firstRow = data[0];
    headers.forEach((header) => {
      if (firstRow.hasOwnProperty(header.name)) {
        outputHeader.push(header.displayName || header.name)
      }
    });
    outputData.push(outputHeader.join(','))

    data.forEach((currentRow) => {
      const rowArray: string[] = [];
      headers.forEach((header) => {
        if (currentRow.hasOwnProperty(header.name)) {
          let currentValue: string = '' + currentRow[header.name];
          if (currentValue === 'null') {
            currentValue = '';
          }
          if (currentValue.indexOf(',') > -1 ) {
            currentValue = '"' +  currentValue + '"';
          }
          rowArray.push(currentValue);
        }
      });
      outputData.push(rowArray.join(','));
    });

    const outputFilename = filename || 'download.csv'
    const csvContent = outputData.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, outputFilename);
    } else {
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', outputFilename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
  }
  return {type: 'csv-downloaded'};
}

export const downloadCSVContent = (csvContent: string, filename?: string) => {
  const outputFilename = filename || 'download.csv'
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, outputFilename);
  } else {
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', outputFilename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  }

  return {type: 'csv-downloaded'};
}

export const arrayBufferToString = (buffer: ArrayBuffer): string => {
  try {
    let data = ''
    const bytes = new Uint8Array( buffer )
    let index = 0
    if (bytes[0] === 0xEF && bytes[1] === 0xBB && bytes[2] === 0xBF) {
      // BOM char throws of the code that evaluates CSV headers.  SO make sure to strip it - EFBBBF
      index = 3
    }
    for (; index < bytes.byteLength; index++) {
      data += String.fromCharCode( bytes[ index ] )
    }
    return data
  } catch (err) {
    return null
  }
}

export interface PluralTextOptions {
  pluralText?: string,
  zeroText?: string,
}
const noPluralTextOptions: PluralTextOptions = {}
export const pluralize = (count: number, text: string, options: PluralTextOptions = noPluralTextOptions): string => {
  return count === 1
    ? `1 ${text}`
    : count === 0
      ? isNil(options.zeroText) ? `0 ${text}s` : options.zeroText
      : isNil(options.pluralText) ? `${count} ${text}s` : `${count} ${options.pluralText}`
}

export const getCommunitiesOptions = (communities: any[]): Types.Option[] => {
  const options = communities.map((community) => ({key: community.identifier, description: community.name}))
  options.unshift(
    {
    description: Constants.PLEASE_SELECT_A_COMMUNITY,
    key: Constants.PLEASE_SELECT_A_COMMUNITY,
    })
  return options
}



// WEBPACK FOOTER //
// ./src/utils.ts